import type { ReactNode } from "react";
import { Icon } from "./icon";

/** The label that marks staff-only data. Every staff-only block carries these exact words. */
export const STAFF_ONLY_LABEL = "Staff only. Never shown to the customer.";

/** The marker of a block that only staff read. It is text, so a screen reader reads it too. */
export function StaffOnlyNote({ children }: Readonly<{ children?: ReactNode }>) {
  return (
    <p className="m-0 flex items-start gap-2 rounded-sm border border-dashed border-muted-foreground bg-muted px-3 py-2 text-sm leading-6 text-foreground">
      <Icon name="square-lock-02" className="mt-1 size-4 shrink-0" />
      <span>
        <strong>{STAFF_ONLY_LABEL}</strong>
        {children === undefined ? null : <> {children}</>}
      </span>
    </p>
  );
}
